import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import GeneralDisclosureService from '../../../core/service/GeneralDisclosureService';
import DisclosureFormPopup from './DisclosureFormPopup';
import DisclosureListItem from './DisclosureListItem';
import { LS_AUTHORITY_KEY, USER_ROLE } from '../../../core/constants/common';

function GeneralDisclosures({ t }) {
	const [list, setList] = useState([]);
	const [showDiscFormPopup, setShowDiscFormPopup] = useState(false);
	const authority = JSON.parse(localStorage.getItem(LS_AUTHORITY_KEY));

	useEffect(() => {
		getDisclosures();
	}, []);

	const saveCallback = (refresh) => {
		setShowDiscFormPopup(false);
		if (!refresh) return;

		getDisclosures();
	};

	const handleShow = () => {
		setShowDiscFormPopup(true);
	};

	const getDisclosures = () => {
		GeneralDisclosureService.getDisclosures(authority.roles.includes(USER_ROLE.SUPER_ADMIN))
			.then((response) => {
				if (response.status !== 200) return;

				setList(response.data);
			})
			.catch((error) => {
			});
	};

	return (
		<>
			<div className="Standards">
				<div className="List_header pb-2">
					<h5 className="MH m-0">{t("Configurations.label")}</h5>
					{authority.roles.includes(USER_ROLE.SUPER_ADMIN) && (
						<div className="py-1 text-end">
							<button className="btn btn-primary" onClick={handleShow}>
								{t("NewUniversalStandard.label")}
							</button>
						</div>
					)}
				</div>

			</div>
			{showDiscFormPopup && <DisclosureFormPopup saveCallback={saveCallback} />}
			{(() => {
				switch (window.location.pathname) {
					case "/admin/disclosures":
						return list?.length > 0 
						? (
							list?.map((item) => (
								<DisclosureListItem
								key={item.id}
								item={item}
								refreshCallback={getDisclosures}/>
							))
						) : (
							<div className="py-3 text-center">
								<h6>{t("NoUnStandardsConfigured.label")}</h6>
								<p>{t("NoUnStandardsConfiguredSubText.label")}</p>
							</div>
						);
					default:
						return null;
				}
			})()}
		</>
	);
}


export default withTranslation()(GeneralDisclosures);
